module.exports = __webpack_public_path__ + "fonts/fa-regular-400.d44ad00.woff";